(async () => {
    const scrollElements = document.querySelectorAll('.scroll-x');

    if (scrollElements) {
        scrollElements.forEach((element) => {
            const dayBlock = element.querySelector('.day-data');
            const scrollElement = element.querySelector('.scroll-content');

            const leftButton = element.querySelector('.scroll-left');
            leftButton.disabled = true;

            leftButton.addEventListener('click', (e) => {
                e.preventDefault();

                scrollElement.scrollBy({
                    left: -150,
                    behavior: 'smooth',
                });
            });

            const rightButton = element.querySelector('.scroll-right');

            rightButton.addEventListener('click', (e) => {
                e.preventDefault();

                scrollElement.scrollBy({
                    left: 150,
                    behavior: 'smooth',
                });
            });

            scrollElement.addEventListener('scroll', (e) => {
                if (scrollElement.scrollLeft === 0) {
                    leftButton.disabled = true;
                    rightButton.disabled = false;

                    if (dayBlock) {
                        dayBlock.classList.remove('folded');
                    }
                } else if (scrollElement.scrollLeft + scrollElement.clientWidth === scrollElement.scrollWidth) {
                    leftButton.disabled = false;
                    rightButton.disabled = true;
                } else {
                    leftButton.disabled = false;
                    rightButton.disabled = false;

                    if (dayBlock) {
                        dayBlock.classList.add('folded');
                    }
                }
            });
        });
    }
})();